export const iconFontAwesomeMediaplaybackMinimize = (
	<i className="fa-solid fa-minimize"></i>
);
